import { REQUEST_STATUSES } from "@/constants/index.js";
import type { Contact } from "@/store/v2/contacts/types";

const initialState = {
  contacts: [],
  count: 0,
  status: REQUEST_STATUSES.IDLE,
  noResults: false,
  err: null,
};

interface ContactsState {
  organizations?: Record<number, ContactDetails>;
  properties?: Record<number, ContactDetails>;
}

interface ContactDetails {
  contacts: Contact[];
  noResults: boolean;
  status: string;
  err: Error | null;
}

interface SelectorParams {
  propertyId?: number;
  organizationId?: number;
}

export const contactsSelector =
  ({ propertyId, organizationId }: SelectorParams) =>
  (state: { contacts: ContactsState }) => {
    const key = organizationId ? "organizations" : "properties";
    const id = organizationId ?? propertyId;
    if (id === undefined) {
      return { ...initialState };
    }
    return {
      ...initialState,
      contacts: state.contacts?.[key]?.[id]?.contacts || [],
      count: state.contacts?.[key]?.[id]?.contacts?.length ?? 0,
      noResults: state.contacts?.[key]?.[id]?.noResults || false,
      status: state.contacts?.[key]?.[id]?.status ?? REQUEST_STATUSES.IDLE,
      err: state.contacts?.[key]?.[id]?.err || null,
    };
  };
